export default __webpack_public_path__ + "static/media/file-info.ddc52e7b.png";